import { BlogIndexHeader } from 'components/blog/blog-index-header';
import { BlogsDisplaySection } from 'components/blogs/blogs-display-section';

const BlogIndexPage = ({ title, ssr }) => {
	const data = ssr.articles?.data || [];
	const meta = ssr.articles?.meta || {};

	// Render
	return (
		<>
			<BlogIndexHeader title={title} />
			<div className='mx-auto px-3 max-w-xl'>
				<BlogsDisplaySection ssr={{ data, meta }} />
			</div>
		</>
	);
};
export { BlogIndexPage };
